'use client';
import { FlexColumn as SharedFlexColumn } from '@launchstore/shared-puck';
import type { FlexColumnProps } from '@launchstore/shared-puck';
export const FlexColumn: any = SharedFlexColumn;
export type { FlexColumnProps };
export default FlexColumn;
